import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          YogaAI
        </Link>
        <ul className="nav-menu">
          <li className="nav-item">
            <Link to="/" className="nav-link">Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/start" className="nav-link">Practice</Link>
          </li>
          {/* <li className="nav-item">
            <Link to="/tutorials" className="nav-link">Tutorials</Link>
          </li> */}
          <li className="nav-item">
            <Link to="/chat" className="nav-link">Chat Assistant</Link>
          </li>
          <li className="nav-item">
            <Link to="/diet" className="nav-link">Diet Plan 🥗</Link>
          </li>
          {/* <li className="nav-item">
            <Link to="/about" className="nav-link">About</Link>
          </li> */}
        </ul>
      </div>
    </nav>
  );
}